import script from "./Snappy-Logos-Dropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Snappy-Logos-Dropdown.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__